import { useState, useEffect, useCallback } from 'react'
import { toast } from 'react-hot-toast'
import { authFetch } from '../lib/api'

export default function BalancePanel({ namespace, onPayout }) {
  const [balance, setBalance] = useState(null)
  const [paying,  setPaying]  = useState(false)

  const loadBalance = useCallback(async () => {
    const res = await authFetch(`/api/namespaces/${namespace.slug}`)
    if (res.ok) setBalance((await res.json()).balance)
  }, [namespace.slug])

  useEffect(() => { loadBalance() }, [loadBalance])

  async function handlePayout() {
    setPaying(true)
    try {
      const res  = await authFetch(`/api/namespaces/${namespace.slug}`, { method: 'POST' })
      const data = await res.json()
      if (!res.ok) throw new Error(data.error)
      toast.success(`Paid out ₹${data.paid.toFixed(2)}! 🎉`)
      setBalance(0)
      onPayout?.()
    } catch (err) {
      toast.error(err.message ?? 'Payout failed')
    } finally {
      setPaying(false)
    }
  }

  if (balance === null) return null

  return (
    <div className="relative overflow-hidden rounded-2xl mb-4 p-4
      bg-gradient-to-r from-violet-400 via-pink-400 to-orange-300 text-white shadow-md">
      {/* Decorative circles */}
      <div className="absolute -top-4 -right-4 w-24 h-24 bg-white/10 rounded-full" />
      <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-white/10 rounded-full" />

      <div className="relative flex items-center gap-4">
        <span className="text-5xl">🐷</span>
        <div className="flex-1">
          <p className="text-xs font-semibold uppercase tracking-widest text-white/80">
            My Pocket Money
          </p>
          <p className="text-3xl font-bold mt-0.5">
            ₹{balance.toFixed(2)}
          </p>
          {balance === 0 && (
            <p className="text-xs text-white/70 mt-0.5">Keep going — you're doing great! ⭐</p>
          )}
        </div>

        <button
          onClick={handlePayout}
          disabled={paying || balance === 0}
          title={balance === 0 ? 'Nothing to pay out yet' : `Pay out ₹${balance.toFixed(2)}`}
          className="flex-shrink-0 bg-white text-violet-700 font-bold text-sm
            px-4 py-2 rounded-xl shadow hover:bg-violet-50 transition
            disabled:opacity-40 disabled:cursor-not-allowed
            focus:outline-none focus:ring-2 focus:ring-white"
        >
          {paying ? 'Paying…' : '💸 Pay me!'}
        </button>
      </div>
    </div>
  )
}
